<template>
  <Row>
    <h1>QA Dashboard</h1>
    <br>
    <AllEventsTable></AllEventsTable>
    <br>
    <FactsByEventsTable></FactsByEventsTable>
    <br>
    <FactsByConflictTable></FactsByConflictTable>
    <br>
    <FactsByDisasterTable></FactsByDisasterTable>
  </Row>
</template>

<script>
import AllEventsTable from "./components/facts_all_events_table.vue";
import FactsByEventsTable from "./components/facts_by_events_table.vue";
import FactsByConflictTable from "./components/facts_by_conflict_table.vue";
import FactsByDisasterTable from "./components/facts_by_disaster_table.vue";

export default {
  components: {
    AllEventsTable,
    FactsByEventsTable,
    FactsByConflictTable,
    FactsByDisasterTable,
  },
};
</script>
